export default "__VITE_ASSET__C7X2I0Pw__"